// src/components/CameraPanel.jsx
import React, { useState } from 'react';
import CameraStream from '../CameraStream';
import './CameraPanel.css';

const CameraPanel = ({ onCapture, onClose }) => {
  const [shotMode, setShotMode] = useState('multi');
  const [lastPhoto, setLastPhoto] = useState(null);

  const handleCapture = (photo, options) => {

    setLastPhoto(photo);
    onCapture(photo, options); // Send to context or parent
  };

  const toggleMode = () => {
    setShotMode(prev => (prev === 'multi' ? 'single' : 'multi'));
  };

  return (
    <div className="camera-panel fullscreen">
      <CameraStream
        onCapture={handleCapture}
        onClose={onClose}
        onToggleMode={toggleMode}
        shotMode={shotMode}
        lastPhoto={lastPhoto}
      />
    </div>
  );
};

export default CameraPanel;
